export default IconExclamationMarkOff => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-exclamation-mark-off" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 19v.01" />
  <path d="M12 15v-3m0 -4v-3" />
  <path d="M3 3l18 18" />
</svg>`;